import React, { Component } from "react";
import {
  Layout,
  Page,
  Card,
  Button,
  ButtonGroup,
  TextField,
  TextStyle,
  Select,
  RadioButton,
  Checkbox,
  Stack,
  Spinner,
  Heading,
  Subheading,
  Badge,
  List,
  Banner,
} from "@shopify/polaris";
import { API } from "aws-amplify";
import Swal from "sweetalert2";
import Upsell from "./Upsell";
import { presets } from "./../resources/Presets";
import isCurrencyCode from "is-currency-code";

let state = {
  isAuthenticating: true,
  proStatus: false,
  hideRating: false,
  barClass: "fspb-green",
  showOn: "all",
  previewWidth: 85,
  styleClass: "fspb-rounded fspb-edge",
  barOffset: 15,
  disableClose: false,
  disableMobile: false,
  disableDecimals: false,
  appearDelay: 2,
  beforeTextEmpty: "Spend ",
  afterTextEmpty: " for free shipping!",
  beforeTextProgress: "Spend ",
  afterTextProgress: " more for free shipping!",
  completedText: "Congratulations! You have unlocked free shipping",
  cartGoal: 50,
  currency: "USD",
  showCurrency: "",
  currencySymbol: "$",
  barLink: "",
  showPercent: 0,
  hideInstructions: false,
  autoCurrency: false,
  isActive: false,
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = state;
  }

  componentDidMount() {
    const { isAuthenticating, hideRating } = this.state;
    if (isAuthenticating) {
      API.get("api", "/status" + window.location.search)
        .then((response) => {
          this.setState({ isAuthenticating: false }); // Otherwise finish authenticating and render the screen
          if (response) {
            // If we got back a response an active charge ID is on record
            this.setState({ proStatus: true });
          }
          this.loadSettings();
        })
        .catch((error) => {
          console.log(error.response); // Otherwise log the error, if any
        });
    }

    if (!hideRating) {
      //  If hideRating is not set to true, check if they're elligible for a review prompt
      API.get("api", "/review" + window.location.search)
        .then((response) => {
          if (response) {
            // If we got back a response they're elligble to get the review prompt
            this.reviewPrompt(response); // prompt them for a review
          }
        })
        .catch((error) => {
          console.log(error.response); // Otherwise log the error, if any
        });
    }
  }

  // Prompts the user for a review
  reviewPrompt(reviewUrl) {
    Swal({
      toast: true,
      position: "bottom-start",
      type: "question",
      title: "Do you find our app helpful?",
      confirmButtonText: "Yes!",
      showCancelButton: true,
      cancelButtonText: "Not really",
      customContainerClass: "review-swal",
    }).then((result) => {
      API.post("api", "/dismiss" + window.location.search, {
        // Make a note in the db to not show the review prompt again (timestamp of dismiss)
        body: {},
      });
      this.setState({ hideRating: true }); // Disable the review hook so we stop on annoying them.
      if (result.value) {
        // If they said yes show the review prompt
        Swal({
          toast: true,
          position: "bottom-start",
          type: "succcess",
          title:
            "We would really appreciate it if you helped our small New Zealand business by rating this app.",
          confirmButtonText: "Sure!",
          showCancelButton: true,
          cancelButtonText: "No thanks",
          customContainerClass: "review-swal",
        }).then((result) => {
          if (result.value) {
            window.open(reviewUrl, "_blank");
          }
        });
      } else {
        // Otherwise give them our condolences
        Swal({
          toast: true,
          position: "bottom-start",
          type: "info",
          title:
            "We are sorry to hear that, please feel free to get in touch with us if we can do anything to help.",
          confirmButtonText: "Okay",
          customContainerClass: "review-swal",
        });
      }
    });
  }

  componentWillUnmount() {
    // Remember our state for the next mount
    state = this.state;
    state.isAuthenticating = true; // Explicitly set the auth state to true
    state.proStatus = false; // Explicitly set the proStatus state to false
  }

  render() {
    const primaryAction = {
      content: this.state.proStatus ? "View Plans" : "Go Pro",
      onAction: () => {
        this.changePage("/pro");
      },
    };
    const secondaryActions = [
      {
        content: "Home",
        onAction: () => {
          this.changePage("/");
        },
      },
      {
        content: "FAQ",
        onAction: () => {
          this.changePage("/faq");
        },
      },
      {
        content: "Privacy Policy",
        onAction: () => {
          this.changePage("/terms");
        },
      },
    ];
    const proUsed = presets.pro.includes(this.state.barClass);
    const goalLeft = (
      this.state.cartGoal *
      (1 - this.state.previewWidth / 100)
    ).toFixed(2);

    if (this.state.isAuthenticating) {
      // If the page hasn't loaded yet, show a placeholder spinner instead
      return (
        <Page
          title="Home"
          primaryAction={primaryAction}
          secondaryActions={secondaryActions}
        >
          <Layout>
            <Layout.Section>
              <Stack alignment="center" distribution="center">
                <Spinner size="large" color="teal" />
              </Stack>
            </Layout.Section>
          </Layout>
        </Page>
      );
    }

    return (
      !this.state.isAuthenticating && (
        <Page
          title="Home"
          primaryAction={primaryAction}
          secondaryActions={secondaryActions}
        >
          <Banner status="critical">
            <TextStyle variation="strong">
              After much consideration, we have decided to sunset the app on the
              5th of October 2024. This app will cease to function on this date.
              We are currently creating a new app that will replace this one.
              And we will notify you once it is available. We apologize for any
              inconvenience this may cause.
            </TextStyle>
          </Banner>
          <div
            style={{
              paddingTop: 20,
            }}
          ></div>
          <Layout>
            <Layout.Section>
              <Card>
                <Card.Section>
                  <Stack alignment="center" distribution="equalSpacing">
                    <Heading>
                      {"Free shipping goal bar " +
                        (this.state.isActive ? "enabled" : "disabled")}
                    </Heading>
                    <Stack alignment="center" distribution="equalSpacing">
                      <Button
                        primary={!this.state.isActive}
                        onClick={this.toggleActive}
                      >
                        {this.state.isActive ? "Disable" : "Enable"}
                      </Button>
                      <Button
                        primary
                        disabled={!isCurrencyCode(this.state.currency)}
                        onClick={this.saveSettings}
                      >
                        Save
                      </Button>
                      <Button destructive onClick={this.resetSettings}>
                        Reset
                      </Button>
                    </Stack>
                  </Stack>
                </Card.Section>
                <Card.Section>
                  <Stack alignment="leading" vertical>
                    <TextField
                      label="Cart goal"
                      prefix={this.state.currencySymbol}
                      min={0}
                      type="number"
                      helpText="Make sure this value matches your free shipping rate."
                      value={this.state.cartGoal}
                      onChange={this.valueUpdater("cartGoal")}
                    />
                    <Stack alignment="leading">
                      <TextField
                        label="Default currency code"
                        onChange={this.valueUpdater("currency")}
                        value={this.state.currency}
                        error={
                          isCurrencyCode(this.state.currency)
                            ? false
                            : "Please enter a valid currency code."
                        }
                      />
                      <TextField
                        label="Default currency symbol"
                        value={this.state.currencySymbol}
                        onChange={this.valueUpdater("currencySymbol")}
                      />
                      <Checkbox
                        checked={this.state.showCurrency}
                        label="Show currency on goal bar"
                        onChange={this.valueUpdater("showCurrency")}
                      />
                      <Checkbox
                        checked={this.state.disableDecimals}
                        label="Disable showing decimals on goal bar"
                        onChange={this.valueUpdater("disableDecimals")}
                      />
                    </Stack>
                    <Heading>IMPORTANT: SET UP YOUR FREE SHIPPING RATE</Heading>
                    <Subheading>
                      If you have not set up your free shipping rate, follow the
                      instructions below then enable your goal bar.
                    </Subheading>
                    {!this.state.hideInstructions && (
                      <List type="number">
                        <List.Item>
                          In your Shopify admin, click "Settings", then click
                          "Shipping".
                        </List.Item>
                        <List.Item>
                          Click "Edit" on the shipping zone where you want to
                          offer free shipping, or click "Add Shipping zone" if
                          you have not yet created a shipping rule for the area
                          you want to offer free shipping.
                        </List.Item>
                        <List.Item>
                          Make sure your shipping zone has the correct country &
                          regions set for where you want to offer free shipping.
                        </List.Item>
                        <List.Item>
                          In the panel "Price based rates" click the button "Add
                          rate", a dialog box should pop up.
                        </List.Item>
                        <List.Item>
                          In the dialog box, give your free shipping rate an
                          appropriate name, then set the field "Minimum order
                          price" to be the same as the cart goal you set within
                          this app.
                        </List.Item>
                        <List.Item>
                          Check the checkbox "Free shipping rate" then click the
                          "Done" button, and finally click the "Save" button.
                        </List.Item>
                        <List.Item>
                          When done, don't forget to enable your goal bar.
                        </List.Item>
                      </List>
                    )}
                    <Checkbox
                      checked={this.state.hideInstructions}
                      label="Hide instructions"
                      onChange={this.valueUpdater("hideInstructions")}
                    />
                  </Stack>
                </Card.Section>
                <Card.Section title="Settings">
                  <Stack alignment="fill">
                    <Select
                      label="Bar style"
                      options={[
                        { label: "Default", value: "fspb-edge fspb-rounded" },
                        { label: "Borderless", value: "fspb-rounded" },
                        { label: "Square", value: "fspb-edge" },
                        { label: "Square Borderless", value: "" },
                        { label: "Full", value: "fspb-full" },
                      ]}
                      onChange={this.valueUpdater("styleClass")}
                      value={this.state.styleClass}
                    />
                    <TextField
                      label="Bar starter percentage"
                      suffix="%"
                      type="number"
                      max={100}
                      min={0}
                      value={this.state.barOffset}
                      onChange={this.valueUpdater("barOffset")}
                    />
                    <TextField
                      label="Show after"
                      suffix="seconds"
                      type="number"
                      max={99}
                      min={0}
                      value={this.state.appearDelay}
                      onChange={this.valueUpdater("appearDelay")}
                    />
                    <Stack
                      alignment="leading"
                      spacing="tight"
                      distribution="fillEvenly"
                      vertical
                    >
                      <Checkbox
                        checked={this.state.disableMobile}
                        label="Disable on mobile"
                        onChange={this.valueUpdater("disableMobile")}
                      />
                      <Checkbox
                        checked={this.state.disableClose}
                        label="Disable close button"
                        onChange={this.valueUpdater("disableClose")}
                      />
                    </Stack>
                  </Stack>
                  <br />
                  <Stack vertical>
                    <TextField
                      label="Message when cart is empty"
                      value={this.state.afterTextEmpty}
                      onChange={this.valueUpdater("afterTextEmpty")}
                      maxLength={100}
                      connectedLeft={
                        <TextField
                          value={this.state.cartGoal}
                          type="number"
                          prefix={this.state.currencySymbol}
                          suffix={
                            this.state.showCurrency ? this.state.currency : ""
                          }
                          disabled={true}
                          max={99}
                          min={0}
                          connectedLeft={
                            <TextField
                              value={this.state.beforeTextEmpty}
                              onChange={this.valueUpdater("beforeTextEmpty")}
                              maxLength={100}
                            />
                          }
                        />
                      }
                    />
                    <TextField
                      label="Message while in progress"
                      value={this.state.afterTextProgress}
                      onChange={this.valueUpdater("afterTextProgress")}
                      maxLength={100}
                      connectedLeft={
                        <TextField
                          value={this.state.cartGoal}
                          type="number"
                          prefix={this.state.currencySymbol}
                          suffix={
                            this.state.showCurrency ? this.state.currency : ""
                          }
                          disabled={true}
                          max={99}
                          min={0}
                          connectedLeft={
                            <TextField
                              value={this.state.beforeTextProgress}
                              onChange={this.valueUpdater("beforeTextProgress")}
                              maxLength={100}
                            />
                          }
                        />
                      }
                    />
                    <TextField
                      label="Message when goal is completed"
                      value={this.state.completedText}
                      onChange={this.valueUpdater("completedText")}
                      maxLength={200}
                    />
                    <TextField
                      label="Link to go to when your goal bar is clicked"
                      value={this.state.barLink}
                      onChange={this.valueUpdater("barLink")}
                      type="url"
                      placeholder="https://example.com"
                      helpText="Leave empty to not link your goal bar."
                    />
                  </Stack>
                </Card.Section>
                <Card.Section title="Pro-Only Settings">
                  <Stack vertical distribution="leading" alignment="leading">
                    <RadioButton
                      label="Show on all pages"
                      disabled={!this.state.proStatus}
                      checked={this.state.showOn === "all"}
                      id="all"
                      name="showOn"
                      onChange={this.showOnUpdater}
                    />
                    <RadioButton
                      label="Show on the homepage only"
                      disabled={!this.state.proStatus}
                      checked={this.state.showOn === "home"}
                      id="home"
                      name="showOn"
                      onChange={this.showOnUpdater}
                    />
                    <RadioButton
                      label="Show everywhere but the homepage"
                      disabled={!this.state.proStatus}
                      checked={this.state.showOn === "nothome"}
                      id="nothome"
                      name="showOn"
                      onChange={this.showOnUpdater}
                    />
                    <RadioButton
                      label="Show on product pages only"
                      disabled={!this.state.proStatus}
                      checked={this.state.showOn === "product"}
                      id="product"
                      name="showOn"
                      onChange={this.showOnUpdater}
                    />
                    <RadioButton
                      label="Show on the cart page only"
                      disabled={!this.state.proStatus}
                      checked={this.state.showOn === "cart"}
                      id="cart"
                      name="showOn"
                      onChange={this.showOnUpdater}
                    />
                    <TextField
                      disabled={!this.state.proStatus}
                      label="Show only after % complete"
                      suffix="%"
                      type="number"
                      max={100}
                      min={0}
                      value={this.state.showPercent}
                      onChange={this.valueUpdater("showPercent")}
                    />
                    <Checkbox
                      checked={this.state.autoCurrency}
                      disabled={!this.state.proStatus}
                      label="Automatically convert the goal value from your default currency into the visitor's local currency based off their geolocation."
                      onChange={this.valueUpdater("autoCurrency")}
                    />
                  </Stack>
                </Card.Section>
                <Card.Section title="Free Color Presets">
                  <Stack alignment="trailing">
                    {presets.free.map((value, index) => {
                      return (
                        <span
                          key={index}
                          className={
                            "fspb-bar shopify-selection " +
                            value +
                            " " +
                            (value === this.state.barClass
                              ? "shopify-selected"
                              : "")
                          }
                          onClick={() => {
                            this.changeGradient(value);
                          }}
                          style={{
                            width: "60px",
                            height: "30px",
                          }}
                        ></span>
                      );
                    })}
                  </Stack>
                </Card.Section>
                <Card.Section title="Pro-Only Color Presets">
                  <Stack alignment="trailing">
                    {presets.pro.map((value, index) => {
                      return (
                        <span
                          key={index}
                          className={
                            "fspb-bar shopify-selection " +
                            value +
                            " " +
                            (value === this.state.barClass
                              ? "shopify-selected"
                              : "")
                          }
                          onClick={() => {
                            this.changeGradient(value);
                          }}
                          style={{
                            width: "60px",
                            height: "30px",
                          }}
                        ></span>
                      );
                    })}
                  </Stack>
                </Card.Section>
                <Card.Section>
                  <Stack alignment="fill" distribution="fill" vertical>
                    <Button
                      primary
                      fullWidth
                      onClick={this.saveSettings}
                      disabled={!isCurrencyCode(this.state.currency)}
                    >
                      Save changes
                    </Button>
                    <Button destructive fullWidth onClick={this.resetSettings}>
                      Reset to default
                    </Button>
                  </Stack>
                </Card.Section>
              </Card>
            </Layout.Section>
            <Layout.Section secondary>
              <Stack vertical alignment="fill">
                <Card>
                  <Card.Section>
                    <Stack alignment="center" distribution="equalSpacing">
                      <Heading>
                        Feeling stuck? Check out our FAQ for answers to our
                        frequent questions.
                      </Heading>
                      <Button
                        onClick={() => {
                          this.changePage("/faq");
                        }}
                      >
                        Visit FAQ
                      </Button>
                    </Stack>
                  </Card.Section>
                </Card>
                {!this.state.proStatus && (
                  <Card>
                    <Card.Section>
                      <Stack alignment="center" distribution="equalSpacing">
                        <Stack alignment="leading" vertical>
                          <Heading>3 reasons to go pro:</Heading>
                          <List type="bullet">
                            <List.Item>
                              Automatically convert the goal value into the
                              visitor's local currency.
                            </List.Item>
                            <List.Item>
                              Only show on select pages or after the customer
                              has reached a certain percentage of your cart
                              goal.
                            </List.Item>
                            <List.Item>
                              Access to 21 pro-only color presets.
                            </List.Item>
                          </List>
                        </Stack>
                        <Button
                          primary
                          onClick={() => {
                            this.changePage("/pro");
                          }}
                        >
                          Learn More
                        </Button>
                      </Stack>
                    </Card.Section>
                  </Card>
                )}
                <Upsell />
              </Stack>
            </Layout.Section>
            <Layout.Section>
              <Stack alignment="center" distribution="equalSpacing">
                <Heading>Preview:</Heading>
                <ButtonGroup segmented>
                  <Button
                    primary={this.state.previewWidth === 0}
                    onClick={() => {
                      this.setPreviewWidth(0);
                    }}
                  >
                    0%
                  </Button>
                  <Button
                    primary={this.state.previewWidth === 85}
                    onClick={() => {
                      this.setPreviewWidth(85);
                    }}
                  >
                    85%
                  </Button>
                  <Button
                    primary={this.state.previewWidth === 100}
                    onClick={() => {
                      this.setPreviewWidth(100);
                    }}
                  >
                    100%
                  </Button>
                </ButtonGroup>
                <div style={{ minWidth: "115px" }}>
                  {proUsed && !this.state.proStatus && (
                    <Badge status="warning">
                      <TextStyle variation="strong">Pro Preset Used</TextStyle>
                    </Badge>
                  )}
                </div>
              </Stack>
              <br />
              <br />
              <div
                className={
                  "fspb-container fspb-show shopify-app-only " +
                  this.state.styleClass
                }
              >
                <div className="fspb-text">
                  {+this.state.previewWidth === 0
                    ? this.state.beforeTextEmpty +
                      this.state.currencySymbol +
                      goalLeft +
                      (this.state.showCurrency
                        ? " " + this.state.currency
                        : "") +
                      this.state.afterTextEmpty
                    : +this.state.previewWidth === 100
                    ? this.state.completedText
                    : this.state.beforeTextProgress +
                      this.state.currencySymbol +
                      goalLeft +
                      (this.state.showCurrency
                        ? " " + this.state.currency
                        : "") +
                      this.state.afterTextProgress}
                </div>
                <span
                  className={"fspb-bar " + this.state.barClass}
                  style={{
                    width:
                      +this.state.barOffset +
                      (100 - +this.state.barOffset) *
                        (this.state.previewWidth / 100) +
                      "%",
                  }}
                ></span>
                {!this.state.disableClose && <div className="fspb-close"></div>}
              </div>
            </Layout.Section>
          </Layout>
        </Page>
      )
    );
  }

  // Change our page, but only if our current page is done loading to prevent memory leaks
  changePage = (url, keepParams = true) => {
    const { isAuthenticating } = this.state;
    if (!isAuthenticating) {
      this.props.history.push(url + (keepParams ? window.location.search : ""));
    }
  };

  changeGradient = (newClass = "") => {
    this.setState({ barClass: newClass });
  };

  setPreviewWidth = (newWidth = 85) => {
    this.setState({ previewWidth: newWidth });
  };

  // Toggle the enable/disabled setting
  toggleActive = () => {
    this.setState(
      ({ isActive }) => ({ isActive: !isActive }),
      () => {
        this.saveSettings();
      }
    ); // save the after enabling/disabling
  };

  // Save the settings
  saveSettings = () => {
    const {
      isAuthenticating,
      proStatus,
      hideRating,
      previewWidth,
      ...settings
    } = this.state; // Strip our state of the settings we don't want to save and put the rest in "settings"

    const isExternalUrl = new RegExp(
      "^(http://www.|https://www.|http://|https://)?[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9]+)*[.][a-zA-Z]{2,5}(:[0-9]{1,5})?(/.*)?$"
    );
    const hasHttps = new RegExp("^(http://|https://)");
    settings.barLink = isExternalUrl.test(settings.barLink)
      ? hasHttps.test(settings.barLink)
        ? settings.barLink
        : "//" + settings.barLink
      : settings.barLink;

    if (
      !this.state.proStatus &&
      (settings.showOn !== "all" ||
        settings.showPercent !== 0 ||
        settings.autoCurrency !== false ||
        presets.pro.includes(settings.barClass))
    ) {
      settings.isActive = false;
      settings.showOn = "all";
      settings.showPercent = 0;
      settings.autoCurrency = false;
      this.setState({ isActive: false });
      API.post("api", "/save" + window.location.search, {
        body: JSON.stringify(settings),
      })
        .then((response) => {
          Swal({
            title: "You've used a pro-only color preset",
            text: "We have saved your settings but your goal bar is currently disabled, before re-enabling please upgrade to the pro plan or select a free color preset.",
            type: "warning",
            showCancelButton: true,
            width: 600,
            backdrop: "rgba(0,0,0,0)",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Go Pro",
            cancelButtonText: "Dismiss",
            showCloseButton: true,
          }).then((result) => {
            if (result.value) {
              this.changePage("/pro"); // Go to the pro page if they press the learn more button
            }
          });
        })
        .catch((error) => {
          console.log(error.response); // Otherwise log the error, if any
        });
    } else {
      API.post("api", "/save" + window.location.search, {
        body: JSON.stringify(settings),
      })
        .then((response) => {
          Swal({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            type: "success",
            title: "Changes saved",
            customContainerClass: "small-swal",
          });
        })
        .catch((error) => {
          console.log(error.response); // Otherwise log the error, if any
        });
    }
  };

  // Reset our settings
  resetSettings = () => {
    Swal({
      title: "Are you sure?",
      text: "Resetting will permanently reset your settings back to the default, and your current settings will not be able to be recovered.",
      type: "warning",
      showCancelButton: true,
      width: 600,
      backdrop: "rgba(0,0,0,0)",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Reset",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        const {
          isAuthenticating,
          proStatus,
          hideRating,
          isActive,
          previewWidth,
          ...defaults
        } = state;
        this.setState(
          () => {
            return defaults;
          },
          () => {
            this.saveSettings();
          }
        );
      }
    });
  };

  // Load the settings from our db into our state
  loadSettings = () => {
    API.get("api", "/load" + window.location.search)
      .then((response) => {
        let loadedSettings = JSON.parse(response);
        if (
          !this.state.proStatus &&
          (loadedSettings.showOn !== "all" ||
            loadedSettings.showPercent !== 0 ||
            loadedSettings.autoCurrency !== false ||
            presets.pro.includes(loadedSettings.barClass))
        ) {
          loadedSettings.isActive = false;
          loadedSettings.showOn = "all";
          loadedSettings.showPercent = 0;
          loadedSettings.autoCurrency = false;
        }
        this.setState(() => {
          return loadedSettings;
        });
      })
      .catch((error) => {
        // console.log(error.response); // Otherwise log the error, if any
      });
  };

  valueUpdater(field) {
    return (value) => this.setState({ [field]: value });
  }

  showOnUpdater = (checked, newValue) => {
    this.setState({ showOn: newValue });
  };
}

export default Home;
